import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-navy px-3 py-4 sm:px-6" data-id="element-41" data-mp="1hd1nvzbcra01">
      <div className="mx-auto max-w-2xl" data-id="element-42" data-mp="1hduki7glkj4g">
        <h2 className="text-center font-display text-[1.45rem] font-extrabold uppercase leading-none text-white sm:text-[2rem]" data-id="element-43" data-mp="1ceqaxfprgjdl">
          FREQUENTLY ASKED <span className="text-signal" data-id="element-44" data-mp="2a1qidfhwkh2t">QUESTIONS</span>
        </h2>
        <ul className="mt-2 space-y-1.5" data-id="element-45" data-mp="252w0qgvo8yka">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className={`overflow-hidden rounded-md border bg-navy-soft transition-colors duration-150 ease-out ${isOpen ? 'border-signal' : 'border-navy-line'}`} data-id="element-46" data-mp="2027zl2dqb1cc" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-2 px-2.5 py-2 text-left font-sans text-[0.78rem] font-semibold text-white transition-colors duration-150 ease-out hover:text-signal focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-signal sm:text-[0.9rem]" data-id="element-47" data-mp="jpjdkk21lztx">
                  {f.q}
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-signal transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-48" data-mp="16nyxoxc1b1ex" />
                </button>
                {isOpen ? <p id={`faq-${i}`} className="px-2.5 pb-2 text-[0.78rem] leading-[1.35] text-white/80 sm:text-[0.88rem]" data-id="element-49" data-mp="ww1m3ph467fo">
                    {f.a}
                  </p> : null}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}